import styled from "styled-components";

export const CardComponent = styled.div`
  button {
    width: 64px;
    height: 64px;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 8px;
    flex-direction: column;
    justify-content: center;
    background-color: #b8976c;
    padding: 6px 4px;
    border: 0;
    gap: 4px;
    box-shadow: none;
    transition: background 0.2s ease;

    :hover {
      background-color: #a8865c;
    }

    svg {
      width: 18px;
      height: 18px;
      color: #ffffff;
    }

    p {
      color: #ffffff;
      text-align: center;
      font-size: 0.55rem;
      font-weight: 700;
      letter-spacing: 0.03em;
      line-height: 1.1;
      margin: 0;
    }
  }
`;
